<template>
    <div class="home1">

        <div class="left">
            <div class="left-box"></div>
        </div>
        <div class="right">
            <div class="right-box"></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Home',
        components: {},
        data() {
            return {}
        }
    }
</script>
<style scoped lang="scss">
    .home1 {
        position: relative;
        width: 100vw;
        .left {
            width: 19.5vw;
            height: 100vh;

            position: absolute;
            left: 0;
            padding-top: 7vh;
            background: url("./../assets/img/left-y.png");
            background-size: 100% 100%;
            box-sizing: border-box;
            .left-box {
                width: 17.5vw;
                height: 100%;
                background: url("./../assets/img/left.png");
                background-size: 100% 100%;
            }
        }
        .right {
            box-sizing: border-box;
            width: 19.5vw;
            height: 93vh;
            padding-top: 7vh;
            position: absolute;
            right: 0;
            top: 0;
            background: url("./../assets/img/right-y.png");
            background-size: 100% 100%;
            .right-box {
                position: absolute;
                right: 0vw;
                width: 17.5vw;
                height: 100%;
                background: url("./../assets/img/right.png");
                background-size: 100% 100%;
            }
        }
    }
</style>
